import { BILLER_API } from '@constants/fastagConstants'
import { errorWithStack } from '@utils/logger'

export const fastagBalanceService = async (regNo, selectedBank): Promise<any> => {
  try {
    const res = await fetch(BILLER_API(regNo, selectedBank.biller_details_id), {
      method: 'GET',
      credentials: 'include',
    })
    const data = await res.json()
    return data?.data[0]
  } catch (err) {
    errorWithStack('error on fastag details', err)
    return null
  }
}

export const fastagBalanceWithErrorService = async (regNo, selectedBank): Promise<any> => {
  try {
    const res = await fetch(BILLER_API(regNo, selectedBank.biller_details_id), {
      method: 'GET',
      credentials: 'include',
    })
    const data = await res.json()
    if (data?.success === false) return data?.error
    return data?.data[0]
  } catch (err) {
    errorWithStack('error on fastag details', err)
    return null
  }
}
